import React from 'react';
import withLayout from '../../components/layout';
import { ROUTE_PATH } from '../../constants/route-constants';
import MyWatchList from '../../components/feature/watch-list/index';

const WatchList = () => {
    return <MyWatchList />;
};

export default withLayout(WatchList, true, true, { search: false, wisList: false, notification: false, back: true, backRoute: ROUTE_PATH.EXPLORE, title: 'WATCH LISTED CARS' });
